import React from 'react';
import { XIcon, AlertCircleIcon } from 'lucide-react';
const mistakes = ['Dietas restrictivas de 1200 calorías que te matan de hambre.', 'Eliminar grupos enteros de alimentos (como los carbohidratos).', 'Pastillas mágicas o batidos que solo te hacen perder líquido.', 'Ejercicio extremo sin darle descanso a tu cuerpo.'];
export function ProblemAgitation() {
  return <section className="py-20 bg-white" data-id="element-170">
      <div className="container mx-auto px-4 max-w-4xl fade-in-section" data-id="element-171">
        <div className="text-center mb-10" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-6" data-id="element-173">
            No es tu culpa.{' '}
            <span className="text-coral" data-id="element-174">El problema no sos vos.</span>
          </h2>
          <p className="text-lg text-text-medium leading-relaxed mb-8" data-id="element-175">
            Durante años nos hicieron creer que para bajar de peso había que
            sufrir. Que la culpa era nuestra por no tener "fuerza de voluntad".
            Pero la ciencia demostró que hacer esto solo empeora las cosas:
          </p>
        </div>

        <div className="bg-bg-warm p-6 md:p-8 rounded-3xl shadow-inner mb-10" data-id="element-176">
          <ul className="space-y-4" data-id="element-177">
            {mistakes.map((mistake, index) => <li key={index} className="flex items-start" data-id="element-178">
                <div className="flex-shrink-0 mt-1 mr-4 bg-rose/20 p-1 rounded-full" data-id="element-179">
                  <XIcon className="text-coral-dark" size={20} data-id="element-180" />
                </div>
                <span className="text-lg text-text-dark font-medium" data-id="element-181">
                  {mistake}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col md:flex-row items-center bg-rose/5 border-l-4 border-coral p-6 rounded-r-2xl mb-12" data-id="element-182">
          <AlertCircleIcon className="text-coral w-12 h-12 mb-4 md:mb-0 md:mr-6 flex-shrink-0" data-id="element-183" />
          <div data-id="element-184">
            <p className="text-xl font-bold text-text-dark mb-2" data-id="element-185">
              Tu metabolismo está bloqueado.
            </p>
            <p className="text-text-medium" data-id="element-186">
              Y mientras no lo reinicies y desinflames tu cuerpo, ninguna dieta
              del mundo va a funcionar a largo plazo. Solo vas a seguir en el
              círculo vicioso del efecto rebote.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-187">
          <h3 className="text-2xl font-bold text-sage-light-dark text-sage mb-2" data-id="element-188">
            Pero hay una forma diferente...
          </h3>
          <div className="w-12 h-1 bg-sage mx-auto rounded-full" data-id="element-189"></div>
        </div>
      </div>
    </section>;
}